import { fs13EmployeeFeedbackMessages } from "../firestore_schemas/fs13EmployeeFeedbackMessages"
import { addDocIn_fs13EmployeeFeedbackMessages } from "../firestore_schemas/fs13EmployeeFeedbackMessages"
import { removeDocFrom_fs13EmployeeFeedbackMessages } from "../firestore_schemas/fs13EmployeeFeedbackMessages"

type Result = {
  debug_data: Array<string>;
  return_msg: string;
  success: boolean;
  error_title: string;
  error_summary: string;
  error_next_steps: string;
};

export async function fs13Writer(
  w_type: string,
  fs1_id: string,
  fs2_id: string,
  fs4_consumer_contact_uid: string,
  fs13_message_uid: string,
  data={employee_uid: "", conversation_uid: "", message_content: "", rating: -1}
) {

  const retval: Result = {
    debug_data: [],
    return_msg: "fs13_writer:fs13Writer ",
    success: true,
    error_title: "",
    error_summary: "",
    error_next_steps: "",
  };

  /// Validate arguments according to write type
  if (!fs1_id || !fs2_id || !fs4_consumer_contact_uid) {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "business_uid or recycler_uid not set.";
    retval.error_next_steps = "Please provide correct business_uid snd recycler_uid.";
    return retval;
  }

  if((w_type === "d" || w_type === "e") && !fs13_message_uid) {
    retval.success = false;
    retval.return_msg += "fs13_id argument missing.";
    retval.error_title = "fs13_id argument missing.";
    retval.error_summary = "Employee feedback record UID missing.";
    retval.error_next_steps = "Please provide correct Employee feedback record UID.";
    return retval;
  }

  if (w_type == "n" && data.message_content == "") {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "message_content or rating not set.";
    retval.error_next_steps = "Please provide correct rating or message_content.";
    return retval;
  }

  /// <END> Validate arguments according to write type

  // Delete record
  if (w_type == "d") {
    await removeDocFrom_fs13EmployeeFeedbackMessages(fs1_id, fs2_id, fs4_consumer_contact_uid,fs13_message_uid);
    return retval
  }

  // Create new record
  if (w_type == "n") {
    await addDocIn_fs13EmployeeFeedbackMessages(
      fs1_id,
      fs2_id,
      fs4_consumer_contact_uid,
      {
        conversation_uid: data.conversation_uid,
        message_type: 1,
        employee_uid: data.employee_uid,
        message_content: data.message_content,
        timestamp: new Date(),
        rating: -1
      }
    )
    return retval
  }

}

function firestoreWriteError(error:any) {
  // TODO - complete this
}
